
import React from "react";
import { Input } from "./input";

interface InternationalPhoneInputProps {
  value: string;
  onChange: (phone: string) => void;
  disabled?: boolean;
  name?: string;
  id?: string;
  placeholder?: string;
  className?: string;
}

export const formatE164 = (raw: string): string => {
  // 只做简单处理: 保留数字及+号，自动保留第一个+，其余忽略
  let cleaned = raw.replace(/[^\d+]/g, "");
  if (cleaned.startsWith("00")) cleaned = "+" + cleaned.slice(2);
  if (!cleaned.startsWith("+")) cleaned = "+" + cleaned;
  // 限制最大长度防止误输入
  return cleaned.slice(0, 17);
};

const InternationalPhoneInput: React.FC<InternationalPhoneInputProps> = ({
  value,
  onChange,
  disabled,
  name,
  id,
  placeholder = "+86 13800138000",
  className = "",
}) => {
  return (
    <Input
      type="tel"
      inputMode="tel"
      pattern="^\+[\d]{6,16}$"
      id={id}
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      value={value}
      onChange={e => {
        const val = formatE164(e.target.value);
        onChange(val);
      }}
      autoComplete="tel"
    />
  );
};

export default InternationalPhoneInput;
